/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, char: NonNullable<unknown> }} Embed_Captions_Illegal_Char_TextInputs */

const en_embed_captions_illegal_char_text = /** @type {(inputs: Embed_Captions_Illegal_Char_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} contains an illegal character (${i?.char}) that is not 608-compliant. Please remove this character before exporting.`)
};

const fr_embed_captions_illegal_char_text = /** @type {(inputs: Embed_Captions_Illegal_Char_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'evenement ${i?.index} contient un caractere illegal (${i?.char}) non conforme 608. Veuillez supprimer ce caractere avant l'exportation.`)
};

const de_embed_captions_illegal_char_text = /** @type {(inputs: Embed_Captions_Illegal_Char_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Das Ereignis ${i?.index} enthält ein ungültiges Zeichen (${i?.char}), das nicht mit 308 kompatibel ist. Bitte entfernen Sie dieses Zeichen vor dem Export.`)
};

const it_embed_captions_illegal_char_text = /** @type {(inputs: Embed_Captions_Illegal_Char_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'evento ${i?.index} contiene un carattere non valido (${i?.char}) che non è conforme allo standard 608. Rimuovere questo carattere prima di esportare.`)
};

const ru_embed_captions_illegal_char_text = /** @type {(inputs: Embed_Captions_Illegal_Char_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Событие ${i?.index} содержит недопустимый символ (${i?.char}), не соответствующий стандарту 608. Пожалуйста, удалите этот символ перед экспортом.`)
};

const es_embed_captions_illegal_char_text = /** @type {(inputs: Embed_Captions_Illegal_Char_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El evento ${i?.index} contiene un carácter no válido (${i?.char}) que no cumple con la norma 608. Elimínelo antes de exportar.`)
};

const zh_cn2_embed_captions_illegal_char_text = /** @type {(inputs: Embed_Captions_Illegal_Char_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`事件 ${i?.index} 包含一个不符合 608 标准的非法字符 (${i?.char})。请在导出前删除此字符。`)
};

const ja_embed_captions_illegal_char_text = /** @type {(inputs: Embed_Captions_Illegal_Char_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント ${i?.index} には、608 に準拠していない不正な文字 (${i?.char}) が含まれています。エクスポートする前にこの文字を削除してください。`)
};

const hi_embed_captions_illegal_char_text = /** @type {(inputs: Embed_Captions_Illegal_Char_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इवेंट ${i?.index} में एक अवैध वर्ण (${i?.char}) है जो 608 के अनुरूप नहीं है। कृपया निर्यात करने से पहले इस वर्ण को हटा दें।`)
};

const pt_pt2_embed_captions_illegal_char_text = /** @type {(inputs: Embed_Captions_Illegal_Char_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O evento ${i?.index} contém um caractere inválido (${i?.char}) que não está em conformidade com a norma 608. Remova este caractere antes de exportar.`)
};

/**
* | output |
* | --- |
* | "Event {index} contains an illegal character ({char}) that is not 608-compliant. Please remove this character before exporting." |
*
* @param {Embed_Captions_Illegal_Char_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_illegal_char_text = /** @type {((inputs: Embed_Captions_Illegal_Char_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Illegal_Char_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_illegal_char_text(inputs)
	if (locale === "de") return de_embed_captions_illegal_char_text(inputs)
	if (locale === "it") return it_embed_captions_illegal_char_text(inputs)
	if (locale === "ru") return ru_embed_captions_illegal_char_text(inputs)
	if (locale === "es") return es_embed_captions_illegal_char_text(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_illegal_char_text(inputs)
	if (locale === "ja") return ja_embed_captions_illegal_char_text(inputs)
	if (locale === "hi") return hi_embed_captions_illegal_char_text(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_illegal_char_text(inputs)
	return en_embed_captions_illegal_char_text(inputs)
});